
import React from 'react';
import { FileVideo2, Edit, Theater, Mic } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useLanguage } from '@/contexts/LanguageContext';

// Map of expression types with their icons
export const expressionInfo = {
  'all': { name: 'all', icon: FileVideo2 },
  'edit': { name: 'edit', icon: Edit },
  'react': { name: 'react', icon: FileVideo2 },
  'acting': { name: 'acting', icon: Theater },
  'other': { name: 'other', icon: Mic },
};

export type ExpressionType = 'all' | 'edit' | 'react' | 'acting' | 'other';

export const expressionTypes: ExpressionType[] = ['all', 'edit', 'react', 'acting', 'other'];

interface DerivativesFilterBarProps {
  expressionFilter: ExpressionType;
  setExpressionFilter: (type: ExpressionType) => void;
  className?: string;
}

export const DerivativesFilterBar = ({ 
  expressionFilter, 
  setExpressionFilter,
  className = ""
}: DerivativesFilterBarProps) => {
  const { t } = useLanguage();
  
  // When filter changes
  const handleFilterChange = (value: string) => {
    setExpressionFilter(value as ExpressionType);
  };
  
  return (
    <div className={className}>
      {/* Filter select */}
      <Select
        value={expressionFilter}
        onValueChange={handleFilterChange}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder={t('common.filterByType')} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {expressionTypes.map(type => (
              <SelectItem key={type} value={type}>
                <div className="flex items-center">
                  {React.createElement(expressionInfo[type].icon, { 
                    className: "h-4 w-4 mr-2" 
                  })}
                  {type === 'all' 
                    ? t('common.allExpressions') 
                    : type
                  }
                </div>
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
